import Layout from '@/layout';
var designWeekRouter = {
  path: '/designWeek',
  component: Layout,
  redirect: '/designWeek/exhibitor',
  name: 'DesignWeek',
  meta: {
    title: '设计周管理',
    icon: 'guide'
  },
  children: [{
    path: 'exhibitor',
    name: 'DesignWeekExhibitor',
    component: function component() {
      return import('@/views/designWeek/exhibitor/page.vue');
    },
    meta: {
      title: '展商名录',
      icon: ''
    }
  }, {
    path: 'edition',
    name: 'DesignWeekEdition',
    component: function component() {
      return import('@/views/designWeek/edition/page.vue');
    },
    meta: {
      title: '届次管理',
      icon: ''
    }
  }]
};
export default designWeekRouter;